module.exports = __webpack_public_path__ + "img/jobs-dashboard.e691e80b.jpg";